import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
function ar(e, t) {
  var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  if (r.rr()) return nr.o().refreshFeatureFlags(e, t, a);
}
export function refreshFeatureFlags(r, e) {
  ar(r, e);
}
export default ar;